import {
  // 壁纸分分类
  GET_WP_CATEGORY_LABELS,
  GET_WP_CATEGORY_IMGINFO,
  // 壁纸推荐
  GET_WP_BANNER_LIST,
  GET_WP_RECOMMEND_LIST,
  GET_WP_DETAIL_RECO_BANNER,
  GET_WP_RECO_BANNER,
  GET_WP_RECO_GROUP,
  GET_WP_RANK_MORE,
  // 壁纸我的
  GET_WP_COLLECT_LIST,
  GET_WP_SETUP_LIST,
  CANCEL_WP_MINE_COLLECTORSETUP,
  // 壁纸其他操作
  GET_WP_OPTERAYTION,
  // 锁屏壁纸List
  GET_WP_SCREEN_LIST,
  // 壁纸公共
  WP_UPDATE_PREVIEW,
  WP_ADD_DOWNLOAD_IMG,
  WP_REMOVE_DOWNLOAD_IMG,
  WP_UPDATE_STATUS_DOWNLOAD_IMG,
  WP_UPDATE_PROGRESS_DOWNLOAD_IMG,
  // 壁纸 作家列表
  GET_WP_AUTHOR_LIST,
  GET_WP_AUTHOR_DETAIL,
  GET_WP_AUTHOR_SHOWREEL,
  SET_WP_CATEGORY_STATUS,
  SET_SCROLL,
} from '../constants/wallpaper';

// 壁纸---分类
export const getCategoryLabels = payload => ({
  type: GET_WP_CATEGORY_LABELS,
  payload,
});
export const getCategoryImgInfo = payload => ({
  type: GET_WP_CATEGORY_IMGINFO,
  payload,
});

// 壁纸精选
export const getBannerList = payload => ({
  type: GET_WP_BANNER_LIST,
  payload,
});
export const getRecommendList = payload => ({
  type: GET_WP_RECOMMEND_LIST,
  payload,
});
export const getDetailReco = payload => ({
  type: GET_WP_DETAIL_RECO_BANNER,
  ...payload,
});
export const getRecoBanner = param => ({
  type: GET_WP_RECO_BANNER,
  ...param,
});
export const getRecoGroup = param => ({
  type: GET_WP_RECO_GROUP,
  ...param,
});
export const getRankList = param => {
  return {
    type: GET_WP_RANK_MORE,
    ...param,
  };
};

// 壁纸我的
export const getMineCollectList = payload => ({
  type: GET_WP_COLLECT_LIST,
  payload,
});

export const getMineSetupList = payload => ({
  type: GET_WP_SETUP_LIST,
  payload,
});

// 壁纸其他操作
export const operationImg = param => ({
  type: GET_WP_OPTERAYTION,
  param,
});

// 锁屏操作
export const getWpScreenList = param => ({
  type: GET_WP_SCREEN_LIST,
  param,
});

export const cancelMineCollectOrSetup = payload => ({
  type: CANCEL_WP_MINE_COLLECTORSETUP,
  payload,
});

// 用户预览壁纸
export const updatePreviewInfo = info => ({
  type: WP_UPDATE_PREVIEW,
  info,
});
// 添加壁纸下载任务
export const addDownloadImg = param => ({
  type: WP_ADD_DOWNLOAD_IMG,
  ...param,
});
// 添加壁纸下载任务
export const removeDownloadImg = param => ({
  type: WP_REMOVE_DOWNLOAD_IMG,
  ...param,
});
// 更新壁纸下载状态
export const updateDownloadImgStatus = param => {
  return {
    type: WP_UPDATE_STATUS_DOWNLOAD_IMG,
    ...param,
  };
};
export const updateDownloadImgProgress = param => {
  return {
    type: WP_UPDATE_PROGRESS_DOWNLOAD_IMG,
    ...param,
  };
};

export const getAuthorList = payload => ({
  type: GET_WP_AUTHOR_LIST,
  payload,
});

export const getAuthorDetail = payload => ({
  type: GET_WP_AUTHOR_DETAIL,
  payload,
});

export const getAuthorShowreel = payload => ({
  type: GET_WP_AUTHOR_SHOWREEL,
  payload,
});

export const setCategoryStatus = payload => ({
  type: SET_WP_CATEGORY_STATUS,
  payload,
});

// 设置壁纸高度相关信息

export const setScroll = payload => ({
  type: SET_SCROLL,
  payload,
});
